<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'
import HomePage from './HomePage.vue'
import Dashboard from '@/pages/Dashboard/index.vue'

const store = useStore()
const authInitialized = computed(() => store.getters.getAuthInitialized)
const isLoggedIn = computed(() => store.getters.getIsLoggedIn)
</script>

<template>
  <template v-if="authInitialized">
    <HomePage v-if="!isLoggedIn" />
    <Dashboard v-else />
  </template>
</template>
